import C from "@/utils/constants";

export default function useFormatters() {
  const userName = (user) => {
    if (user.firstName && user.lastName) {
      return titleCase(`${user.firstName} ${user.lastName}`);
    } else if (user.firstName) {
      return titleCase(user.firstName);
    } else if (user.lastName) {
      return titleCase(user.lastName);
    }

    return "";
  };

  const agentName = (agent) => {
    let name = "";
    if (agent.name) {
      if (
        agent.name.first &&
        agent.name.first !== "" &&
        agent.name.last &&
        agent.name.last !== ""
      ) {
        let firstName = agent.name.first;
        let lastName = agent.name.last;
        firstName = firstName.replace(/^./, firstName[0].toUpperCase());
        lastName = lastName.replace(/^./, lastName[0].toUpperCase());
        name = `${firstName} ${lastName}`;
      } else if (agent.name.first && agent.name.first !== "") {
        let firstName = agent.name.first;
        firstName = firstName.replace(/^./, firstName[0].toUpperCase());
        name = `${firstName}`;
      } else if (agent.name.last && agent.name.last !== "") {
        let lastName = agent.name.last;
        lastName = lastName.replace(/^./, lastName[0].toUpperCase());
        name = `${lastName}`;
      } else if (agent.name.display) {
        name = agent.name.display;
        name = name.replace(/^./, name[0].toUpperCase());
      }
    }

    return name;
  };

  const referralName = (referral) => {
    if (!referral || !referral.name) {
      return "";
    }

    if (referral.name.first && referral.name.last) {
      return titleCase(`${referral.name.first} ${referral.name.last}`);
    } else if (referral.name.first) {
      return titleCase(referral.name.first);
    } else if (referral.name.last) {
      return titleCase(referral.name.last);
    }

    return "";
  };

  const referralOverdue = (referral) => {
    let today = new Date();

    if (referral.updated && referral.stage) {
      let updated = new Date(referral.updated);
      let difference = today.getTime() - updated.getTime();
      let days = difference / (24 * 3600 * 1000);
      if (
        days > 7 &&
        referral.stage !== C.REFERRAL_STATUS.REMOVED &&
        referral.stage !== C.REFERRAL_STATUS.CLOSED &&
        referral.stage !== C.REFERRAL_STATUS.LONG_TERM_HOLD &&
        referral.stage !== C.REFERRAL_STATUS.UNDER_CONTRACT &&
        referral.stage !== C.REFERRAL_STATUS.LEASED
      ) {
        return true;
      }
    }

    if (
      referral.details &&
      referral.details.referralSale &&
      referral.details.referralSale.dateOfSale &&
      referral.stage &&
      referral.stage === C.REFERRAL_STATUS.UNDER_CONTRACT
    ) {
      let saleDate = new Date(referral.details.referralSale.dateOfSale);
      console.log(saleDate);
      let difference = today.getTime() - saleDate.getTime();
      let days = difference / (24 * 3600 * 1000);
      if (days > 1) {
        return true;
      }
    }

    return false;
  };

  const referralOverdueDays = (referral) => {
    let today = new Date();

    if (referral.updated && referral.stage) {
      let updated = new Date(referral.updated);
      let difference = today.getTime() - updated.getTime();
      let days = difference / (24 * 3600 * 1000);
      if (
        days > 7 &&
        referral.stage !== C.REFERRAL_STATUS.REMOVED &&
        referral.stage !== C.REFERRAL_STATUS.CLOSED &&
        referral.stage !== C.REFERRAL_STATUS.LONG_TERM_HOLD &&
        referral.stage !== C.REFERRAL_STATUS.UNDER_CONTRACT &&
        referral.stage !== C.REFERRAL_STATUS.LEASED
      ) {
        return Math.floor(days);
      }
    }

    if (
      referral.details &&
      referral.details.referralSale &&
      referral.details.referralSale.dateOfSale &&
      referral.stage &&
      referral.stage === C.REFERRAL_STATUS.UNDER_CONTRACT
    ) {
      let saleDate = new Date(referral.details.referralSale.dateOfSale);
      console.log(saleDate);
      let difference = today.getTime() - saleDate.getTime();
      let days = difference / (24 * 3600 * 1000);
      if (days > 1) {
        return Math.floor(days);
      }
    }

    return 0;
  };

  const opportunityName = (opportunity) => {
    if (opportunity.prospect && opportunity.prospect.name) {
      let name = opportunity.prospect.name;
      if (name.first && name.last) {
        return `${name.first} ${name.last}`;
      } else if (name.first) {
        return name.first;
      } else if (name.last) {
        return name.last;
      }
    }

    return "";
  };

  const opportunityCosignerName = (opportunity) => {
    let name = "";

    if (opportunity?.cosignerFirstName) {
      name += opportunity.cosignerFirstName;
    }
    if (opportunity?.cosignerLastName) {
      name += ` ${opportunity.cosignerLastName}`;
    }

    return name.trim();
  };

  const leadName = (lead) => {
    if (lead.contact) {
      let contact = lead.contact;
      if (contact.nameFirst && contact.nameLast) {
        return `${contact.nameFirst} ${contact.nameLast}`;
      } else if (contact.nameFirst) {
        return contact.nameFirst;
      } else if (contact.nameLast) {
        return contact.nameLast;
      }
    }

    return "";
  };

  const titleCase = (str) => {
    let words = str.trim().toLowerCase().split(" ");
    let titled = words.map((w) => {
      if (w[0] === undefined) {
        return "";
      }

      // exceptions to title-casing
      if (
        w === "sms" ||
        w === "rcb" ||
        w === "csr" ||
        w === "ds" ||
        w === "qa"
      ) {
        return w.toUpperCase();
      }

      return w[0].toUpperCase() + w.slice(1);
    });

    return titled.join(" ");
  };

  const prettyPrintEnum = (str) => {
    let pp = str.toLowerCase();
    pp = pp.replace(/_/g, " ");
    pp = titleCase(pp);
    return pp;
  };

  const prettyPrintOwnerType = (ownerTypeStr) => {
    let pp = ownerTypeStr;
    if (ownerTypeStr === "LEAD_GENIUS_BROKER") {
      pp = "IRIS";
    } else if (ownerTypeStr === "PRIMESTREET") {
      pp = "PrimeStreet";
    }
    return pp;
  };

  const formatRole = (role) => {
    switch (role) {
      case C.ROLE.CSR:
        return "CSR";

      case C.ROLE.CSR_SUPERVISOR:
        return "CSR Supervisor";

      case C.ROLE.QA_TEAM:
        return "QA Team";

      default:
        return prettyPrintEnum(role);
    }
  };

  const truncateString = (str, maxLength) => {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + "...";
    }
    return str;
  };

  const formatDate = (dateString) => {
    let date = new Date(dateString);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const formatDateMonthDay = (dateString) => {
    let date = new Date(dateString);
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };

  const formatDateLong = (dateString) => {
    let date = new Date(dateString);
    return `${date.toLocaleString("en-us", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const formatDateServer = (date) => {
    if (date) {
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const year = date.getFullYear();

      return [year, month, day].join("-");
    }

    return "";
  };

  const formatTime24to12 = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? "am" : "pm"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  };

  const formatTime = (dateString) => {
    let date = new Date(dateString);

    let meridiem = "";
    let hours = date.getHours();
    if (hours < 12) {
      meridiem = "AM";
      hours = hours === 0 ? 12 : hours;
    } else if (hours === 12) {
      meridiem = "PM";
    } else if (hours > 12) {
      meridiem = "PM";
      hours = hours - 12;
    }

    let minutes = date.getMinutes();
    let minString = minutes < 10 ? `0${minutes}` : `${minutes}`;

    return `${hours}:${minString} ${meridiem}`;
  };

  const formatTimeDuration = (duration) => {
    const secsPerHour = 3600;
    const secsPerMin = 60;

    let hours = Math.floor(duration / secsPerHour);
    let minutes = Math.floor((duration - hours * secsPerHour) / secsPerMin);
    let seconds = `${Math.ceil(
      duration - hours * secsPerHour - minutes * secsPerMin,
    )}`;

    if (hours > 0) {
      let minuteStr = `${minutes}`;
      return `${hours}:${minuteStr.padStart(2, "0")}:${seconds.padStart(
        2,
        "0",
      )}`;
    }

    return `${minutes}:${seconds.padStart(2, "0")}`;
  };

  const formatTimeDurationString = (duration, short = false) => {
    const secsPerHour = 3600;
    const secsPerMin = 60;

    let hours = Math.floor(duration / secsPerHour);
    let minutes = Math.floor((duration - hours * secsPerHour) / secsPerMin);
    let seconds = Math.ceil(
      duration - hours * secsPerHour - minutes * secsPerMin,
    );

    if (hours > 0) {
      let hourString = short ? "h" : hours === 1 ? " hour" : " hours";
      let minuteString = short ? "m" : minutes === 1 ? " minute" : " minutes";
      let secondString = short ? "s" : seconds === 1 ? " second" : " seconds";

      return `${hours}${hourString} ${minutes}${minuteString} ${seconds}${secondString}`;
    } else if (minutes > 0) {
      let minuteString = short ? "m" : minutes === 1 ? " minute" : " minutes";
      let secondString = short ? "s" : seconds === 1 ? " second" : " seconds";

      return `${minutes}${minuteString} ${seconds}${secondString}`;
    } else {
      let secondString = short ? "s" : seconds === 1 ? " second" : " seconds";

      return `${seconds}${secondString}`;
    }
  };

  const formatTimeZone = (dateString, short = true) => {
    let date = new Date(dateString);
    console.log("%%%%%%%%%%%%%%%%");
    console.log(date.toString());
    // return date.toString().match(/\(([A-Za-z\s].*)\)/)[1];
    let tz = date.toString().match(/\(([A-Z\s].*)\)/)[1];
    if (short) {
      tz = tz.match(/[A-Z]/g).slice(0, 3).join("");
    }

    return tz;
  };

  const timeObject = (h, m) => {
    let hStandard = h === 0 ? 12 : h > 12 ? h - 12 : h;
    let meridiem = h >= 12 ? "PM" : "AM";
    let hPadded = `${h}`.padStart(2, "0");
    let mPadded = `${m}`.padStart(2, "0");
    return {
      display: `${hStandard}:${mPadded} ${meridiem}`,
      value: `${hPadded}:${mPadded}:00.000`,
      hour: h,
      minute: m,
    };
  };

  const formatPhoneNumber = (phoneNumber) => {
    // if (!phoneNumber) {
    //   return "";
    // }

    if (phoneNumber) {
      let cleaned = phoneNumber.replace(/\D/g, "");
      if (cleaned.length > 10) {
        cleaned = cleaned.substr(cleaned.length - 10);
      }
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return `(${match[1]}) ${match[2]} - ${match[3]}`;
      }

      return phoneNumber;
    }

    return "";
  };

  const formatPhoneFormInputMask = (phoneNumber) => {
    if (phoneNumber) {
      let cleaned = phoneNumber.replace(/\D/g, "");
      if (cleaned.length > 10) {
        cleaned = cleaned.substr(cleaned.length - 10);
      }
      return cleaned;
    }
    return "";
  };

  const formatPhoneNumberFormPost = (phoneNumber) => {
    return phoneNumber ? `+1${phoneNumber.replace(/[^0-9]/g, "")}` : "";
  };

  const formatCurrency = (currency, decimals) => {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimals,
    });

    return formatter.format(currency);
  };

  const formatPriceRange = (priceRange) => {
    if (priceRange.min && priceRange.max) {
      return `$${formatPriceAbbreviated(
        priceRange.min,
      )} - $${formatPriceAbbreviated(priceRange.max)}`;
    } else if (priceRange.min) {
      return `$${formatPriceAbbreviated(priceRange.min)} and above`;
    } else if (priceRange.max) {
      return `Less than $${formatPriceAbbreviated(priceRange.max)}`;
    }

    return "";
  };

  const formatPriceAbbreviated = (price) => {
    const division = 1000;

    if (price < division) {
      return `${Math.floor(price)}`;
    }

    let abbr = "K";
    let divided = price / division;

    if (divided >= division) {
      divided = divided / division;
      abbr = "M";
    }

    return `${Math.floor(divided)}${abbr}`;
  };

  const formatNumberWithCommas = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const formatNumberPadding = (num, pad) => {
    return `${num}`.padStart(pad, "0");
  };

  const numbersOnly = (v) => {
    return v.replace(/\D/g, "");
  };

  const isNumber = (event, value, decimal) => {
    console.log(`isNumber: ${value}`);
    if (decimal) {
      if (!/\d/.test(event.key) && (event.key !== "." || /\./.test(value))) {
        return event.preventDefault();
      }
    } else {
      if (!/\d/.test(event.key)) {
        return event.preventDefault();
      }
    }
  };

  const isPhoneNumber = (event, value) => {
    console.log(`isPhoneNumber: ${value}`);
    if (
      !/\d/.test(event.key) &&
      (event.key !== "+" || /\+\d{11}?/.test(value))
    ) {
      return event.preventDefault();
    }
  };

  const isValidPhoneNumber = (value) => {
    const digitsOnly = String(value).replace(/\D/g, "");

    console.log("digis only: ", digitsOnly);
    if (digitsOnly.length !== 10) {
      return false;
    }

    // if (digitsOnly.match(/^0+$/)) {
    //   return false;
    // }

    return true;
  };

  const isValidEmailAddress = (value) => {
    const testEmailExp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return testEmailExp.test(value);
  };

  const isAllowedNameCharacter = (event) => {
    let char = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z-]+$/.test(char)) {
      return true;
    } else {
      event.preventDefault();
    }
  };

  const formatAddress = (addr1, addr2, city, state, zip) => {
    let addr = [];
    if (addr1 && addr1 !== "") {
      addr.push(prettyPrintEnum(addr1));
    }

    if (addr2 && addr2 !== "") {
      addr.push(prettyPrintEnum(addr2));
    }

    if (city && city !== "" && state && state !== "" && zip && zip !== "") {
      addr.push(`${prettyPrintEnum(city)}, ${state.toUpperCase()} ${zip}`);
    } else if (city && city !== "" && state && state !== "") {
      addr.push(`${prettyPrintEnum(city)}, ${state.toUpperCase()}`);
    } else if (city && city !== "" && zip && zip !== "") {
      addr.push(`${prettyPrintEnum(city)} ${zip}`);
    } else if (state && state !== "" && zip && zip !== "") {
      addr.push(`${state.toUpperCase()} ${zip}`);
    } else if (city && city !== "") {
      addr.push(prettyPrintEnum(city));
    } else if (state && state !== "") {
      addr.push(state.toUpperCase());
    } else if (zip && zip !== "") {
      addr.push(zip);
    }

    return addr;
  };

  const dayKeyToText = (key) => {
    switch (key) {
      case "sun":
        return "Sunday";
      case "mon":
        return "Monday";
      case "tue":
        return "Tuesday";
      case "wed":
        return "Wednesday";
      case "thu":
        return "Thursday";
      case "fri":
        return "Friday";
      case "sat":
        return "Saturday";
    }

    return "Undefined";
  };

  return {
    userName,
    agentName,
    referralName,
    referralOverdue,
    referralOverdueDays,
    opportunityName,
    opportunityCosignerName,
    leadName,
    titleCase,
    prettyPrintEnum,
    prettyPrintOwnerType,
    formatRole,
    truncateString,
    formatDate,
    formatDateMonthDay,
    formatDateLong,
    formatDateServer,
    formatTime24to12,
    formatTime,
    formatTimeDuration,
    formatTimeDurationString,
    formatTimeZone,
    timeObject,
    formatPhoneNumber,
    formatPhoneFormInputMask,
    formatPhoneNumberFormPost,
    formatCurrency,
    formatPriceRange,
    formatPriceAbbreviated,
    formatNumberWithCommas,
    formatNumberPadding,
    numbersOnly,
    isNumber,
    isPhoneNumber,
    isValidPhoneNumber,
    isValidEmailAddress,
    isAllowedNameCharacter,
    formatAddress,
    dayKeyToText,
  };
}
